<template>
  <mdb-tbl class="ml-3 my-2 fsize-m" sm >
    <mdb-tbl-head>
      <tr class="">
        <th>포트폴리오 과목명</th>
        <th>평가</th>
      </tr>
    </mdb-tbl-head>
    <mdb-tbl-body v-if="subjects" >
      <!-- NCS 포트폴리오 -->
      <template v-for="s in NcsPortfolios">
        <tr :key="s._id">
          <td class="bolder">
            <mdb-icon icon="chalkboard-teacher" /> {{s.name}}
          </td>
        </tr>
        <tr v-for="l in s.lectures" :key="l._id">
          <td class="pl-4"><mdb-icon icon="chalkboard" /> {{l.name}}</td>
          <td>
            <div v-if="getTest(l.code)">
              <span class="pointer" @click="onEdit(getTest(l.code)._id)">
                {{$strDate(getTest(l.code).testDate)}}
              </span>
              <delete-btn-xs class="ml-2" @click="onDelete(l.code)"/>
            </div>
            <div v-else><add-btn-sm  @click="onAdd(l)">만들기</add-btn-sm></div>
          </td>
        </tr>
      </template>
      <!-- 비 NCS 포트폴리오 -->
      <tr v-for="s in NonNcsPortfolios" :key="s._id">
        <td v-if="getTest(s.name)" class="bolder">
          <mdb-icon icon="chalkboard-teacher" /> {{s.name}}
        </td>
        <td v-else><mdb-icon icon="chalkboard-teacher" /> {{s.name}}</td>
        <td>
          <div v-if="getTest(s.name)">
            <span class="pointer" @click="onEdit(getTest(s.name)._id)">
              {{$strDate(getTest(s.name).testDate) || '날짜없음'}}
            </span>
            <delete-btn-xs class="ml-2" @click="onDelete(s.name)"/>
          </div>
          <div v-else><add-btn-sm  @click="onAdd(s)">만들기</add-btn-sm></div>
        </td>
      </tr>
    </mdb-tbl-body>
  </mdb-tbl>
</template>
<script>
import { mdbTabs } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import Training from '@/models/Training'
export default {
  name: 'StaffOpenTrainingPortfolio',
  // components: { PortfolioTestList },
  data () {
    return {
      TAG: 'StaffOpenTrainingPortfolio >>',
      subjects: undefined,
      tests: undefined
    }
  },
  computed: {
    NcsPortfolios () {
      const ncs = this.subjects.NCS.filter(s => s.lectures.filter(l => l.portfolio).length)
        .map(s => ({
          name: s.name,
          lectures: s.lectures
        }))
      ncs.forEach(s => {
        s.lectures = s.lectures.filter(l => l.portfolio)
          .map(({ name, code }) => ({ subject: s.name, name, code, training: this.$route.query.training }))
      })
      return ncs
    },
    NonNcsPortfolios () {
      const nonNcs = this.subjects.NONNCS.filter(s => s.portfolio)
        .map(({ name }) => ({
          subject: name, name, code: name, training: this.$route.query.training
        }))
      return nonNcs
    }
  },
  methods: {
    // 등록된 문제지 리턴
    getTest (code) {
      if (!this.tests || !this.tests[code]) return
      return this.tests[code]
    },
    // 포트폴리오 평가지 만들기
    async onAdd (subject, name, code) {
      if (!confirm('새로운 평가지를 만들까요?\n(새로운 평가지가 자동으로 등록됩니다.)')) return
      let test = this.$PortfolioTest.create(subject)
      test = await test.save()
      this.onEdit(test._id)
    },
    // 수정 페이지로 이동
    onEdit (_id) {
      this.$router.push({
        path: 'edit',
        query: { _id }
      })
    },
    async onDelete (code) {
      if (!confirm('삭제할까요?')) return
      await this.tests[code].delete()
      this.tests[code] = undefined
    },
    // subjects와 문제지 맵 로드
    async load () {
      const { training } = this.$route.query
      this.subjects = await this.$getSubjects(training)
      this.tests = await this.$getPortfolioTests(training)
      // console.log(this.tests)
    }
  },
  created () {
    this.load()
  }
}
</script>
